import { NgModule } from '@angular/core';
import { InttotextPipe } from './inttotext/inttotext';
import { MandatenamePipe } from './mandatename/mandatename';
@NgModule({
	declarations: [InttotextPipe, MandatenamePipe],
	imports: [],
	exports: [InttotextPipe, MandatenamePipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts